export class ApiError extends Error {
    constructor(message, status, code) {
        super(message);
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: code
        });
        this.name = 'ApiError';
    }
}
export async function requestJson(method, url, body) {
    const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        const errorBody = (await response.json().catch(() => null));
        throw new ApiError(errorBody?.error ?? `Request to ${url} failed: ${response.status}`, response.status, errorBody?.code);
    }
    return (await response.json());
}
export async function getJson(url) {
    const response = await fetch(url);
    if (!response.ok) {
        const errorBody = (await response.json().catch(() => null));
        throw new ApiError(errorBody?.error ?? `Request to ${url} failed: ${response.status}`, response.status, errorBody?.code);
    }
    return (await response.json());
}
export async function postJson(url, body) {
    return requestJson('POST', url, body);
}
export async function patchJson(url, body) {
    return requestJson('PATCH', url, body);
}
export async function deleteJson(url, body) {
    return requestJson('DELETE', url, body);
}
export async function getSession() {
    const response = await fetch('/api/session');
    if (!response.ok) {
        throw new Error(`Failed to load session: ${response.status}`);
    }
    return (await response.json());
}
export async function checkEmail(email, placeId, locale) {
    return postJson('/api/check-email', { email, placeId, locale });
}
export async function register(payload) {
    return postJson('/api/registration', payload);
}
export async function verifyMagicLink(token, locale) {
    return postJson('/api/magic-link/verify', { token, locale });
}
export async function logout() {
    await fetch('/api/logout', { method: 'POST' });
}
